import { render, staticRenderFns } from "./OrgManager.vue?vue&type=template&id=8da200c4&scoped=true&"
import script from "./OrgManager.vue?vue&type=script&lang=js&"
export * from "./OrgManager.vue?vue&type=script&lang=js&"
import style0 from "./OrgManager.vue?vue&type=style&index=0&id=8da200c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da200c4",
  null
  
)

export default component.exports